import React from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { Box, Button, Text } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import FormInput from '../../../../components/form/FormInput';
import { getValidationObject, validationTypes } from '../../../../constants/regexPatterns';
import { hideModal } from '../../../../redux/modules/modal';
import { useSendEmailAutomationStepReport } from '../../../../services/email-automation-service';
import colors from '../../../../styles/theme/foundation/colors';

const ReportDownloadModal = ({ step }) => {
  const dispatch = useDispatch();
  const useFormMethods = useForm();
  const { handleSubmit } = useFormMethods;
  const { mutate: initiateExport } = useSendEmailAutomationStepReport({ stepId: step.id });

  const handleDownloadReport = data => {
    const { email } = data;

    initiateExport({ email });

    dispatch(hideModal());
  };

  return (
    <form>
      <Box>
        <Text color={colors.greyScale['900']} mb={4} textStyle="displaySm">Download Report</Text>

        <Text color={colors.greyScale['900']} mb={4} textStyle="bodyXl500">{step.name}</Text>

        <Text my={2}>PINS will capture any resources that qualify the parameters of the automation step and send a report to the email addresses provided below.</Text>

        <FormInput
          disableEnterKey
          required
          inputName="email"
          labelName="Email Addresses"
          placeholder="Enter comma separated email addresses"
          useFormMethods={useFormMethods}
          validationRules={getValidationObject(validationTypes.commaSeparatedEmailAddress)}
        />

        <Button
          variant="gradientSuccess"
          onClick={handleSubmit(handleDownloadReport)}
        >
          Download Report
        </Button>
      </Box>
    </form>
  );
};

ReportDownloadModal.propTypes = {
  step: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired
  }).isRequired
};

export default ReportDownloadModal;
